module.exports = __webpack_public_path__ + "static/left768-8058aa1f28308cb2b6477ad7b1223bfb.png";